module.exports = __webpack_public_path__ + "img/svg/background-ranked-classification.14965e42f76132241b3fc850b782ea94.svg";